import { AbstractView } from 'src/app/core/abstract_view';
import { Component, Injectable, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';

@Injectable()
@Component({
    selector: 'app-report-menu',
    templateUrl: './report-menu.component.html',
})
export class ReportMenuComponent extends AbstractView implements OnInit {
    public model: any[] = [];

    constructor(public messageService: MessageService, public router: Router) {
        super(messageService, router);
    }

    ngOnInit(): void {
        if (this.getAuth(['MANAGE_REPORT_PDV_COMPLAINS'])) {
            this.model.push(
                {
                    label: 'Reportes PDV',
                    icon: '',
                    routerLink: [`/reportsMiddleware/complaints`],
                },
            );
        } else if (this.getAuth(['MANAGE_REPORT_COMMISSION_MDW'])) {
            this.model.push(
                {
                    label: 'Reportes PDV',
                    icon: '',
                    routerLink: [`/reportsMiddleware/commissions`],
                },
            );
        }
        if (this.getAuth(['MANAGE_REPORT_STOCK_PDV'])) {
            this.model.push(
                {
                    label: 'Stock PDV',
                    icon: '',
                    routerLink: [`/stockPdv`],
                },
            );
        }
        // Monitor exclusivo (también se valida en hq-gateway con hasAuthority)
        if (this.getAuth(['MANAGE_MONITOR_MOVEMENTS'])) {
            this.model.push(
                {
                    label: 'Monitor de movimientos',
                    icon: '',
                    routerLink: [`/movementsMonitor`],
                },
            );
        }
        if (this.getAuth(['MANAGE_REPORT_PDV'])) {
            this.model.unshift( // add element to the beginning of the array
                {
                    label: 'Reportes',
                    icon: '',
                    routerLink: [`/reports/megapos`],
                }
            );
            return;
        }

        if (this.getAuth(['MANAGE_REPORT_TREASURER'])) {
            this.model.unshift(
                {
                    label: 'Reportes',
                    icon: '',
                    routerLink: [`/reports/treasurer`],
                },
            );
            return;
        }

        if (this.getAuth(['MANAGE_REPORT_ACCOUNT'])) {
            this.model.unshift(
                {
                    label: 'Reportes',
                    icon: '',
                    routerLink: [`/reports/account`],
                },
            );
            return;
        }
        if (this.getAuth(['MANAGE_REPORT_COMMISSION'])) {
            this.model.unshift(
                {
                    label: 'Reportes',
                    icon: '',
                    routerLink: [`/reports/commission`],
                },
            );
            return;
        }
        if (this.getAuth(['MANAGE_REPORT_CLOSE_CASH'])) {
            this.model.unshift(
                {
                    label: 'Reportes',
                    icon: '',
                    routerLink: [`/reports/treasurer`],
                },
            );
            return;
        }
    }
}
